import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from '@/components/feature/HeroBanner';
import HotComicsSection from './components/HotComicsSection';
import LatestUpdatesSection from './components/LatestUpdatesSection';
import CategorySection from './components/CategorySection';
import RecommendedSection from './components/RecommendedSection';
import SEOHead from './components/SEOHead';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead />
      <Navbar />
      <main>
        <HeroBanner />
        <HotComicsSection />
        <LatestUpdatesSection />
        <CategorySection />
        <RecommendedSection />
        {/* Stats section */}
        <section className="py-14 md:py-20 bg-gradient-to-b from-background-50 to-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
              {[
                { value: '10,000+', label: '韩漫资源', icon: 'ri-book-open-line' },
                { value: '500万+', label: '月活用户', icon: 'ri-user-heart-line' },
                { value: '99.9%', label: '高清画质', icon: 'ri-hd-line' },
                { value: '24h', label: '日更速度', icon: 'ri-timer-flash-line' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-3 flex items-center justify-center rounded-2xl bg-accent-100">
                    <i className={`${stat.icon} text-xl md:text-2xl text-accent-600`} />
                  </div>
                  <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                    {stat.value}
                  </p>
                  <p className="text-sm text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}